"use strict";

var Transmit = function () {

  var set_route_locations = function() {
    var route_data = $('#transmit_route_id').select2('data')[0];
    if ((route_data['id'] !== '') && (route_data['id'] !== undefined)) {
      $('#transmit_company_id').append("<option value='" + route_data['company_id'] + "' selected>" + route_data['company_name'] + "</option>").trigger('change');
      $('#transmit_dep_place_id').val(route_data['dep_place_id']);
      $('#transmit_dep_place_name').val(route_data['dep_place_name']);
      $('#transmit_dep_lat').val(route_data['dep_lat']);
      $('#transmit_dep_lng').val(route_data['dep_lng']);
      $('#transmit_dep_city_id').append("<option value='" + route_data['dep_city_id'] + "' selected>" + route_data['dep_city_name'] + "</option>").trigger('change');
      $('#transmit_arv_place_id').val(route_data['arv_place_id']);
      $('#transmit_arv_place_name').val(route_data['arv_place_name']);
      $('#transmit_arv_city_id').append("<option value='" + route_data['arv_city_id'] + "' selected>" + route_data['arv_city_name'] + "</option>").trigger('change');
      $('#transmit_arv_lat').val(route_data['arv_lat']);
      $('#transmit_arv_lng').val(route_data['arv_lng']);
      $('#transmit_route_km').val(route_data['trans_km']);
    }
    event.preventDefault();
  }

  var set_loading_point_location = function() {
    var point_data = $('#transmit_loading_points_attributes_0_place_id').select2('data')[0];
    console.log('Load Point changed ' + point_data['id']);
    if ((point_data['id'] !== '') && (point_data['id'] !== undefined)) {
      $('#transmit_dep_place_id').val(point_data['id']);
      $('#transmit_dep_place_name').val(point_data['text']);
      $('#transmit_dep_lat').val(point_data['lat']);
      $('#transmit_dep_lng').val(point_data['lng']);
      $('#transmit_dep_city_id').append("<option value='" + point_data['city_id'] + "' selected>" + point_data['city_name'] + "</option>").trigger('change');
    }
    event.preventDefault();
  }

  var set_unloading_point_location = function() {
    var point_data = $('#transmit_unloading_points_attributes_0_place_id').select2('data')[0];
    console.log('Unload Point changed ' + point_data['id']);
    if ((point_data['id'] !== '') && (point_data['id'] !== undefined)) {
      $('#transmit_arv_place_id').val(point_data['id']);
      $('#transmit_arv_place_name').val(point_data['text']);
      $('#transmit_arv_city_id').append("<option value='" + point_data['city_id'] + "' selected>" + point_data['city_name'] + "</option>").trigger('change');
      $('#transmit_arv_lat').val(point_data['lat']);
      $('#transmit_arv_lng').val(point_data['lng']);
    }
    event.preventDefault();
  }

  var set_transmit_points_origin_destination = function(ev) {
    var route_data = ev.select2('data')[0];
    var route_field_id  = '#' + ev.attr('id');
    var origin_field_id = route_field_id.replace('route_id', 'origin_place_id');
    var origin_field    = $(origin_field_id);
    var origin_place_id = ev.select2('data')[0]['dep_place_id'];
    var origin_place_code = ev.select2('data')[0]['dep_place_name'];
    if (typeof origin_field !== typeof undefined && origin_field !== false && origin_place_code != null) {
      origin_field.append("<option value='"+origin_place_id+"' selected>"+origin_place_code+"</option>").trigger('change');
    }

    var destination_field_id   = route_field_id.replace('route_id', 'destination_place_id');
    var destination_field      = $(destination_field_id);
    var destination_place_id   = ev.select2('data')[0]['arv_place_id'];
    var destination_place_code = ev.select2('data')[0]['arv_place_name'];
    if (typeof destination_field !== typeof undefined && destination_field !== false && destination_place_code != null) {
      destination_field.append("<option value='"+destination_place_id+"' selected>"+destination_place_code+"</option>").trigger('change');
    }
  }

  var set_owned_rented_vehicle_fields = function(contract_type) {
    if (contract_type == "rented")  {
      return RoadPositionForm.handleRented();
    }
    else if (contract_type == "owned")  {
      return RoadPositionForm.handleOwned();
    }
    else if (contract_type == "unknown") {
      return RoadPositionForm.handleUnknown();
    }
  }

  return {
    init: function () {

      RoadPositionForm.init($(".transmit_contract_type").val());
      $(document).on('click', '.transmit_contract_type', function(event) {
        set_owned_rented_vehicle_fields($(this).val());
      });

      $(document).on("change", "#transmit_loading_points_attributes_0_place_id", function(event) {
        set_loading_point_location();
      });

      $(document).on("change", "#transmit_unloading_points_attributes_0_place_id", function(event) {
        set_unloading_point_location();
      });

      $(document).on('change', '#transmit_route_id', function(event) {
        set_route_locations();
      });

      $(document).on("change", ".route-select", function(event) {
        set_transmit_points_origin_destination($(this));
      });
    }
  };
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Transmit;
}
